import React, { useState, useEffect } from 'react';

import Layout from '../components/Common/Layout';
import Banner from '../components/Banners/CommonBanner';
import BlogCategory from '../components/Blogs/BlogCategory';
import BlogList from '../components/Blogs/BlogList';
import Footer from '../components/Common/Footer';

import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCkePRhWUzarWRSNIZucR2Uahicxg-U0P8",
  authDomain: "van-portfolio.firebaseapp.com",
  projectId: "van-portfolio",
  storageBucket: "van-portfolio.appspot.com",
  messagingSenderId: "613293751876",
  appId: "1:613293751876:web:fec713b49eb35fcb298611",
  measurementId: "G-HJ9YRJNTVN"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();

export { db };


function Blog() {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fn = async () => {
      const result = await db.collection('blogs').get();

      if (!result.empty) {
        const data = await result.docs.map((doc) => ({ ...doc.data() }));
        setBlogs(data);
        console.log(data)
      }
    }

    fn();
  }, [db]);

  return (
    <Layout>
      <Banner title={'Blog'} link={'/blog'}/>
      <BlogCategory />
      <BlogList />
      <Footer />  
    </Layout>    
  )
}

export default Blog;